import * as types from './mutation-types';

export default {
  [types.SET_USED_ZPOS](state, payload) {
    state.usedZpos = payload;
  },
  [types.SET_ZPOS_CONFIGURATED](state, payload) {
    state.zposConfigurated = payload;
  },
  [types.SET_ZPOS_INTEGRATOR_COLLECTION](state, payload) {
    state.zposIntegratorCollection = payload;
  },
};
